export default function filterPriceSend()
{
    $('.price_slider').on('slidechange', function () {
        $('form#filter_by_price').submit();
    });
}


// WEBPACK FOOTER //
// ./scripts/components/filter-price-send/init.js